<div class="modal-backdrop" *ngIf="visible" [@modalAnimation] (click)="onBackdropClick($event)">
    <div class="modal-content" [@contentAnimation]>
        <div class="modal-body">
            <h3 class="modal-title" *ngIf="title">{{ title }}</h3>
            <ng-content></ng-content>
            <div class="modal-footer">
                <button *ngIf="showCancel" class="btn btn-cancel" (click)="onCancel()">
                    {{ 'Common.Modal.cancel' | translate }}
                </button>
                <button class="btn" [class.btn-danger]="confirmDanger" [class.btn-primary]="!confirmDanger"
                    (click)="onConfirm()">
                    {{ 'Common.Modal.confirm' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>